import * as React from 'react';
import { Panel } from '../bootstrap-components/BootstrapComponents';

export interface SectionGroupProps {
    children: any;
    header?: any;
    buttons?: any;
    halfWidth?: boolean;
    leftHalf?: boolean;
    className?: string;
    id?: string;
    ref?: string;
}

export function SectionGroup(props: SectionGroupProps) {
    let width = props.halfWidth !== undefined && props.halfWidth ? 'half-width ' : '';
    let position: string = '';

    if (props.halfWidth !== undefined && props.halfWidth) {
        position = props.leftHalf !== undefined && props.leftHalf ? 'left' : 'right';
    }

    let classes = 'section-group ' + width + position;

    classes = props.className !== undefined ? classes + ' ' + props.className : classes;

    return (
        <div className={classes} id={props.id} ref={props.ref}>
            <Panel header={props.header} buttons={props.buttons}>
                {props.children}
            </Panel>
        </div>
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/SectionGroup.tsx